module.exports = __webpack_public_path__ + "static/img/wlgz.2cdcda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/wlgz.png
// module id = iZ6+
// module chunks = 44